"use strict";
const userMenuButton = document.getElementById('user-menu-button');
const userMenu = document.getElementById('user-menu');
if (userMenuButton instanceof HTMLElement && userMenu instanceof HTMLElement) {
    userMenuButton.addEventListener('click', () => {
        userMenu.classList.toggle('hidden');
    });
}
